document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('[data-modal]');
    const modalClose = document.querySelector('[data-modal-close]');
    const playVideo = document.querySelector('[data-play-video]');

    playVideo.onclick = function() {
        modal.classList.add("is-active");
    }

    modalClose.onclick = function() {
        modal.classList.remove("is-active");
    }

    window.onclick = function(event) {
        if (event.target === modal) {
            modal.classList.remove("is-active");
        }
    }
})